import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=73b43d6c&"
import script from "./Window.vue?vue&type=script&lang=ts&"
export * from "./Window.vue?vue&type=script&lang=ts&"
import style0 from "./Window.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports